import React from "react";
import { connect } from "react-redux";
import Cuenta from "./Cuenta";

import {
    GetScreenData,
    seleccionarCombo,
    guardarCampoCuenta,
    selectComboProducto,
    validarCuenta,
    cancelar,
    reiniciarEstado
} from '../actions/Actions';

const mapStateToProps = (state) => {
    return {
        data: state.cuenta,
        tarjetas: state.tarjetas
    };
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        GetScreenData(state, currentScope, cuenta) {
            dispatch(GetScreenData(state, currentScope, cuenta));
        },
        seleccionarCombo(valor, combo, ...params) {
            dispatch(seleccionarCombo(valor, combo, ...params));
        },
        guardarCampoCuenta(valor, campo, ...params) {
            dispatch(guardarCampoCuenta(valor, campo, ...params));
        },
        selectComboProducto(id) {
            dispatch(selectComboProducto(id));
        },
        validarCuenta() {
            dispatch(validarCuenta());
        },
        cancelar() {
            dispatch(cancelar());
        },
        reiniciarEstado() {
            dispatch(reiniciarEstado())
        }
    }
}

const CuentaContainer = connect(mapStateToProps, mapDispatchToProps)(Cuenta);

export default CuentaContainer;